import { SalesPoint, salesPointGetAddress, salesPointTypeName, salesPointTypeIndex } from '@prodcard/core'
import { Workbook } from 'exceljs'
import { orderBy } from 'lodash'

const SUM_AREA_INDEX = 5
const SUM_MAX_POPULATION_INDEX = 6

export function createSheetSalesPoints(
  workbook: Workbook,
  sheetName: string,
  opts: { salesPoints: SalesPoint[]; count: number },
) {
  let salesPoints = opts.salesPoints
  const worksheet = workbook.addWorksheet(sheetName)

  let sumArea = 0
  let sumMaxPopulation = 0

  worksheet.columns = [
    { header: 'Наименование хозяйствующего субъекта, осуществляющего торговую деятельность', width: 80 },
    { header: 'ИНН хозяйствующего субъекта', width: 40 },
    { header: 'Наименование торгового объекта', width: 40 },
    { header: 'Тип', width: 25 },
    { header: 'Торговая площадь (кв. м)', width: 25 },
    { header: 'Возможности по прикреплению населения (тыс. чел.)', width: 50 },
    { header: 'Отметка об уведомлении', width: 40 },
    { header: 'Режим работы', width: 25 },
    { header: 'Контактный телефон', width: 25 },
  ]

  salesPoints = orderBy(salesPoints, salesPoint => salesPointTypeIndex(salesPoint.type), 'asc')

  salesPoints.forEach(sp => {
    sumArea += sp.area
    sumMaxPopulation += sp.maxPopulation || 0

    worksheet.addRow([
      sp.name,
      sp.inn,
      salesPointGetAddress(sp) + (sp.comment ? ` (${sp.comment})` : ''),
      salesPointTypeName(sp.type),
      sp.area,
      sp.maxPopulation,
      sp.notificationMark,
      sp.openingHours,
      sp.phone,
    ])
  })

  const row = worksheet.addRow([`Итого: ${opts.count}`, ...new Array(worksheet.columns.length - 1)])

  const cellSumArea = row.getCell(SUM_AREA_INDEX)
  const cellSumMaxPopulation = row.getCell(SUM_MAX_POPULATION_INDEX)
  cellSumArea.value = sumArea
  cellSumMaxPopulation.value = sumMaxPopulation

  row.eachCell(cell => {
    cell.style = { font: { bold: true } }
  })
}
